import React from "react"
import VolunteerActivismOutlinedIcon from '@mui/icons-material/VolunteerActivismOutlined';
import CCOHeadline from "../../fundamentals/CCOHeadline";
import CCOCard from "../../fundamentals/CCOCard";
import CCOIcon from "../../fundamentals/CCOIcon";
import Box from "@mui/material/Box";
import CCOSvg from "../../fundamentals/CCOSvg";
import getSetting, {
    SETTING_FACTS_MAX_LENGTH,
    SETTING_FACTS_TEASER_TITLE_MAX_LENGTH
} from "../../../pages/config/settings";
import CCORichText from "../../fundamentals/CCORichText/CCORichText";
import {metaDataElementWithId} from "../../preview/previewMetaData";
import {usePreviewContext} from "../../../context/PreviewContext";
import {CmTeasableType} from "../../types";


import type { CAEGlobalSettings } from "../../../types/CAEGlobalSettings";

interface Props {
    item: CmTeasableType;
    CAEGlobalSettings: CAEGlobalSettings
}

function C010FactsCard(props: Props) {
    const defaultTeaserTextMaxLength = 178;
    const defaultTeaserTitleLength = 40;

    return <CCOCard item={props.item} paddingY={8} paddingX={6}
                    noLink={true} {...metaDataElementWithId(usePreviewContext().isPreview,
                                                            props.item.id)}>
        <Box sx={{mb: 6, textAlign: 'center'}}>
            {props.item.globalFactsSettings?.teaser_icon ?
                <CCOSvg uri={props.item.globalFactsSettings?.teaser_icon} dark={false}
                        circled={true} size={40} circleSize={60}/>
                : <CCOIcon><VolunteerActivismOutlinedIcon/></CCOIcon>}
        </Box>

        <Box sx={{textAlign: 'center'}}>
            <CCOHeadline metadataId={props.item.id} headline={props.item.teaserTitle}
                         propertyName='properties.teaserTitle'
                         subtextPropertyName='properties.teaserText'
                         headlineCharLimit={getSetting(props.CAEGlobalSettings,
                                                       SETTING_FACTS_TEASER_TITLE_MAX_LENGTH,
                                                       defaultTeaserTitleLength)}
                         type={'h4'}
                         subtext={props.item.teaserText?.textAsTree}
                         margin={{b: 2}}
            />
            {props.item.teaserText ?
                <CCORichText metadataId={props.item.id}
                             textAsTree={props.item.teaserText.textAsTree}
                             alignContent='center'
                             propertyName='properties.teaserText'
                             charLimit={getSetting(props.CAEGlobalSettings,
                                                   SETTING_FACTS_MAX_LENGTH,
                                                   defaultTeaserTextMaxLength)}/> : <></>}
        </Box>
    </CCOCard>
}

export default C010FactsCard